export default __webpack_public_path__ + "/dist/images/interact-icon.svg";